import Api from './base.api';

interface IClassesApi {
  fetch: (id: string) => Promise<any>;
  add: (params: {
    name: string;
    teacherName: string;
    minStudentsNumber: string | number;
    maxStudentsNumber: string | number;
    schoolBus: boolean;
    institution: string;
    project: string;
  }) => Promise<any>;
  delete: (id: string) => Promise<any>;
  edit: (params: any) => Promise<any>;
}

class ClassesApi extends Api implements IClassesApi {
  fetch = (id: string) => this.request(`classes?projectId=${id}`);

  add = (params: {
    name: string;
    teacherName: string;
    minStudentsNumber: string | number;
    maxStudentsNumber: string | number;
    schoolBus: boolean;
    institution: string;
    project: string;
  }) =>
    this.request('classes/add', {
      method: 'post',
      body: JSON.stringify(params),
    });

  delete = (id: string) =>
    this.request(`classes/${id}/remove`, {
      method: 'delete',
    });

  edit = (params: any) => {
    if (typeof params.institution !== 'string') {
      delete params.institution;
    }

    this.request(`classes/${params._id}/edit`, {
      method: 'post',
      body: JSON.stringify(params),
    });
  };
}

export default new ClassesApi();
